import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Breadcrumb, Container, Spinner } from 'react-bootstrap';
import TimeLine, { TimelineHeaders, SidebarHeader, DateHeader } from 'react-calendar-timeline';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import 'react-calendar-timeline/lib/Timeline.css';

import itemRender from './itemRender';
import './employeesTimeLines.css';
import CustomNavbar from '../../../components/CustomNavbar';
import SidebarDashboard from '../../../components/SidebarDashboard';
import HeaderWithSearchForm from '../../../components/header_with_search_form/HeaderWithSearchForm';
import FilterButtons from '../../../components/filter_buttons/FilterButtons';
import { getFilterButtonsConfig } from './filterButtonsConfig';
import { getScheduleTrackingPlannedVacationsEmployee } from '../../../redux/vacations/schedule_tracking_planned_vacations_employee/actions';
import { findUserRole, isUserEmployee } from '../../../utils/findValueFromArray';
import { searchTypes, roles } from './variables';
import SearchAvanceForm from '../../../components/search_avance_form/SearchAvanceForm';
import useQueryParams from '../../../hooks/useQueryParams';

const EmployeesTimeLines = () => {

  const history = useHistory();

  const [show, setShow] = useState(false);
  //const [searchYear, setSearchYear] = useState(moment().year());
  const [isShowSearchAvanceForm, setIsShowSearchAvanceForm] = useState(false);
  const dispatch = useDispatch();
  const { isLoadingData,
  scheludeTrackingPlannedVacationsEmployee,
  scheludeTrackingPlannedVacationsEmployeeFailure } = useSelector(state => state.scheduleTrackingPlannedVacationsEmployee);
  const { userRoles } = useSelector((store) => store.auth);
  
  const isEmployee = isUserEmployee(userRoles);
  const queryParams = useQueryParams();
  const [filter, setFilter] = useState(() => ({
    type: searchTypes.SIMPLE_SEARCH,
    filter: queryParams.get('usercode') ? queryParams.get('usercode') : ''
  }));

  const searchEmployeesEvents = useCallback((ft=filter) => { //, year=searchYear
    const params = {
      rol: findUserRole(userRoles, roles),
      anio: moment().year(),
      auto_consulta: queryParams.get('usercode') ? true : false
    }
    params[ft.type === 'SIMPLE_SEARCH' ? 'filtro' : 'filtro_avanzado'] = ft.filter;
    dispatch(getScheduleTrackingPlannedVacationsEmployee(params));
  }, [filter, userRoles, dispatch]);


  useEffect(() => {
    if (userRoles.length > 0) {
      searchEmployeesEvents();
    }
  }, [userRoles, searchEmployeesEvents])
  
  const onShowSidebar = () => setShow(show ? false : true);
  
  const onSearch = (e) => {
    e.preventDefault();
    const ft = {type: searchTypes.SIMPLE_SEARCH, filter: e.target.search.value};
    setFilter(ft);
    searchEmployeesEvents(ft);
  };

  const onListAll = () => {
    const ft = "";
    setFilter(ft);
    searchEmployeesEvents(ft);
  }
  const onShowSearchAvanceForm = () => {
    setIsShowSearchAvanceForm(true);
  }

  const avancedSearch = (avancedSearchParams) => {
    const ft = {
      type: searchTypes.ADVANCED_SEARCH,
      filter: avancedSearchParams
    };
    setFilter(ft);
    searchEmployeesEvents(ft);
  }

  const navigateToVacationBalance = () => {
    history.push('/saldo-vacaciones');
  }

  const filterButtonsConfig = getFilterButtonsConfig(onListAll, onShowSearchAvanceForm, findUserRole(userRoles, roles), navigateToVacationBalance); //setSearchYear, searchYear,

  // const onItemResize = (itemId, time, edge) => {
  //   dispatch(updateScheduleTrackingPlannedVacationsEmployee(itemId, { end_date: moment(time).format('YYYY-MM-DD') }));
  // }

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {
            !isEmployee && (
              <Breadcrumb className="mb-3">
                <Breadcrumb.Item href="/saldo-vacaciones">Saldo de vacaciones</Breadcrumb.Item>
                <Breadcrumb.Item active>Agenda de seguimiento</Breadcrumb.Item>
              </Breadcrumb>
            )
          }
          <HeaderWithSearchForm 
            onSearch={onSearch} 
            title="Agenda de seguimiento"
            showNewRecordButton={false}
            isDisabledSearchControl={isEmployee ? true : false} />
          <hr />
          <div className='mb-3'>
            <FilterButtons buttons={filterButtonsConfig} />
          </div>
          {
            scheludeTrackingPlannedVacationsEmployeeFailure && (
              <Alert variant="danger" className="mt-4 mb-3">
                {scheludeTrackingPlannedVacationsEmployeeFailure}
              </Alert>
            )
          }
          { isLoadingData ? ( <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>) : (
            <TimeLine
              //onItemResize={onItemResize}
              //onItemMove={(itemId, dragTime, newGroupOrder) => { alert(`move ${moment(dragTime).format('DD/MM/YYYY')}`); }}
              groups={scheludeTrackingPlannedVacationsEmployee ? scheludeTrackingPlannedVacationsEmployee.empleados : []}
              items={scheludeTrackingPlannedVacationsEmployee ? scheludeTrackingPlannedVacationsEmployee.eventos_empleados : []}
              itemRenderer={itemRender}
              lineHeight={75}
              sidebarWidth={350}
              sidebarContent="Classes"
              defaultTimeStart={moment().add(-12, 'hour')}
              defaultTimeEnd={moment().add(12, 'hour')}
              maxZoom={1.5 * 365.24 * 86400 * 1000}
              minZoom={1.24 * 86400 * 1000 * 7 * 3}
              fullUpdate
              itemTouchSendsClick={false}
              stackItems
              itemHeightRatio={0.75}
              showCursorLine
              canMove={true}
              canResize={'both'} >
              <TimelineHeaders className="time-line-header">
                <SidebarHeader>
                  {({ getRootProps }) => {
                    return <div className="d-flex justify-content-center align-items-center"><h6 {...getRootProps()} className="sidebar-header-text-color" >Empleados</h6></div>;
                  }}
                </SidebarHeader>
                <DateHeader unit="primaryHeader" />
                <DateHeader />
              </TimelineHeaders>
            </TimeLine>
          ) }
        </Container>
      </div>
      <SearchAvanceForm 
        isShowSearchModal={isShowSearchAvanceForm} 
        setIsShowSearchModal={setIsShowSearchAvanceForm}
        searchFunc={avancedSearch} />
    </>
  )
}

export default EmployeesTimeLines;